import { render, staticRenderFns } from "./NewOtherIncome.vue?vue&type=template&id=15ad5fc2&scoped=true&"
import script from "./NewOtherIncome.vue?vue&type=script&lang=js&"
export * from "./NewOtherIncome.vue?vue&type=script&lang=js&"
import style0 from "./NewOtherIncome.vue?vue&type=style&index=0&id=15ad5fc2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ad5fc2",
  null
  
)

export default component.exports